import axiosInstance from "../../../services/config/axiosinstance";
import AdminConfigModel from '../../../models/AdminConfigModel';
import { urlBaseAccreditation } from './../../config/index';

export default async function saveConfigApi(
  eventId = '',
  fieldId = 0,
  value = ''
) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/mobileConfig/saveMobileConfig`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        eventId: parseInt(eventId),
        attributeId: fieldId,
        value: value
      }
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return AdminConfigModel({
      id: _ret.data.data.id,
      fieldId: _ret.data.data.attributeId,
      value: _ret.data.data.value
    });
  } catch (error) {
    console.log('Error saveConfigApi', error);
    throw error;
  }
}
